
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { AddNewForwardForm } from "../form/AddNewForwardForm";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column
//   align-items: flex-end;
// `;


type AddNewForwardDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
};

export const AddNewForwardDrawer: React.FC<AddNewForwardDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer()

  return (

    <Drawer
      title={t("url_forward.actions.add_new.drawer.title")}
      placement="right"
      width={500}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
      {
        isDrawerOpen &&
        <AddNewForwardForm
          referenceDrawer={referenceDrawer}
          onCloseDrawer={setDrawerOpen}
        />
      }
    </Drawer>
  );
};
